import type { AxiosRequestConfig } from "axios";
import instance from "../api/instance.ts";


export const getData = async <T>(url: string, config?: AxiosRequestConfig) => {
  const res = await instance.get<T>(url, config);
  return res.data;
};

export const postData = async <Payload, Response>(
  url: string,
  data: Payload,
  config?: AxiosRequestConfig
): Promise<Response> => {
  try {
    const res = await instance.post<Response>(url, data, config);
    return res.data;
  } catch (error) {
    console.error("Error in postData:", error);
    throw error;
  }
};

export const updateData = async <Payload, Response>(
  url: string,
  data: Payload,
  config?: AxiosRequestConfig
): Promise<Response> => {
  try {
    const res = await instance.put<Response>(url, data, config);
    return res.data;
  } catch (error) {
    console.error("Error in postData:", error);
    throw error;
  }
};

export const deleteData = async <Response>(
  url: string,
  config?: AxiosRequestConfig
): Promise<Response> => {
  try {
    const res = await instance.delete<Response>(url, config);
    return res.data;
  } catch (error) {
    console.error("Error in postData:", error);
    throw error;
  }
};
